export interface ObservableArrayChangeListenner{
    listChanged(array);
}
export class DelegatedObservableArrayChangeListenner implements ObservableArrayChangeListenner{
    private hander:(array:any)=>void;
    constructor(parent:object,eventHandler : (array:any)=>void) {
        this.hander = eventHandler.bind(parent);
    }
    listChanged(array: any) {
        this.hander(array);
    }
}
export class ObservableArray<T> extends Array<T>
{
    clone(): ObservableArray<T> {
        let newList:ObservableArray<T> = ObservableArray.create<T>();
        newList.push(...this);
        return newList;
    }
    
    update(...children:T[]): any {
        super.splice(0,this.length);
        super.push(...children);
        this.raiseChangeEvent();
    }
    merge(lst: T[]): ObservableArray<T> {
        let newList = ObservableArray.create<T>();
        newList.push(...this);
        newList.mergeInPlace(lst);
        return newList;
    }

    mergeInPlace(lst: T[]): ObservableArray<T> {
        let any=false;
        for(let i=0;i<lst.length;i++){
            if(this.indexOf(lst[i])==-1){
                super.push(lst[i]);
                any = true;
            }
        }
        if(any)
            this.raiseChangeEvent();
        return this;
    }
    private _changeListenners : ObservableArrayChangeListenner[];

    static create<T>(): ObservableArray<T> {
        const result =  Object.create(ObservableArray.prototype);
        result._changeListenners = [];
        return result;
    }
    public addChangeListenner(listenner:ObservableArrayChangeListenner):void{
        this._changeListenners.push(listenner);
    }
    public removeChangeListenner(listenner:ObservableArrayChangeListenner):void{
        var index = this._changeListenners.indexOf(listenner);
        if(index>-1){
            this._changeListenners.splice(index,1);
        }
    }

    private raiseChangeEvent(){
        this._changeListenners.forEach(element => {
            element.listChanged(this);
        });
    }

    public set length(v : number) {
        super.length = v;
    }
    public get length(){
        if(super.length)
            return super.length;
        else
            return 0;
    }
    pop(): T {
        const result = super.pop();
        this.raiseChangeEvent();
        return result;
    }
    push(...items: T[]): number {
        const result = super.push(...items);
        this.raiseChangeEvent();
        return result;
    }

    insertAt(index:number,...items:T[]){
        this.splice(index, 0, ...items);
    }
    concat(...items: ConcatArray<T>[]): T[];
    concat(...items: (T | ConcatArray<T>)[]): T[];
    concat(...items: any[]) {
        const result = super.concat(...items);
        this.raiseChangeEvent();
        return result;
    }
    
    join(separator?: string): string {
        const result = super.join(separator);
        return result;
    }
    reverse(): T[] {
        const result = super.reverse();
        this.raiseChangeEvent();
        return result;
    }
    shift(): T {
        const result = super.shift();
        this.raiseChangeEvent();
        return result;
    }
    slice(start?: number, end?: number): T[] {
        const result = super.slice(start, end);
        return result;
    }
    sort(compareFn?: (a: T, b: T) => number): this {
        super.sort(compareFn);
        this.raiseChangeEvent();
        return this;
    }

    clear(){
        this.splice(0,this.length);
    }

    splice(start: number, deleteCount?: number): T[];
    splice(start: number, deleteCount: number, ...items: T[]): T[];
    splice(start: any, deleteCount?: any, ...rest: any[]) {
        const result = super.splice(start, deleteCount, ...rest);
        this.raiseChangeEvent();
        return result;
    }

    remove(...list: T[]): any {
        let found =false;
        for(let i=0;i<list.length;i++){
            const index = this.indexOf(list[i]);
            if(index>-1){
                found = true;
                super.splice(index,1);
            }
        }
        if(found)
            this.raiseChangeEvent();
    }

    unshift(...items: T[]): number {
        const result = super.unshift(...items);
        this.raiseChangeEvent();
        return result;
    }
    
    fill(value: T, start?: number, end?: number): this {
        super.fill(value,start,end);
        this.raiseChangeEvent();
        return this;
    }
    copyWithin(target: number, start: number, end?: number): this {
        super.copyWithin(target,start,end);
        this.raiseChangeEvent();
        return this;
    }
    
}